export default {
  userRolesSection: {
    title: {
      fr: "Qui contrôle quoi... et où",
      en: "Who controls what… and where",
    },
    subtitle: {
      fr: "Utilisateurs & rôles",
      en: "Users & roles",
    },
    description: {
      fr: "Attribuez des rôles prédéfinis aux utilisateurs.",
      en: "Assign predefined roles to users.",
    },
    feature: {
      multiHouses: {
        title: {
          fr: "Multi logements",
          en: "Multiple properties",
        },
        subtitle: {
          fr: "",
          en: "",
        },
        description: {
          fr: "Centralisez et gérez plusieurs logements\ndepuis l'application Polynhome.",
          en: "Centralize and manage multiple properties\nfrom the Polynhome app.",
        },
      },
    },
  },
};
